import '../Components/message.css';
import '../Components/button.css'; 

import React, {useEffect} from 'react';

import errIcon from '../Resources/error96.png';
import okIcon from '../Resources/correcto.svg';

// src/message.jsx
// Si tienes un Message.css específico, impórtalo.
// Si no, los estilos relevantes deben estar en App.css como los puse antes.
// Por coherencia, usaré los estilos que ya definimos en App.css para .message-overlay y .message-content

// Componente de Icono reutilizable (opcional pero bueno para la organización)
const MessageIcon = ({ type }) => {
  if (type === 'success') {
    return <img src={okIcon} alt="Éxito" className="message-icon" />;
  }
  if (type === 'error') {
    return <img src={errIcon} alt="Error" className="message-icon" />;
  }
  // Podrías tener un icono 'info' o 'warning' aquí también
  return null;
};

export const Message = ({ onClose, type, message, title: propTitle, showContactInfoOnError = false }) => {
  useEffect(() => {
    const handleEscKeyPress = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKeyPress);
    return () => {
      document.removeEventListener('keydown', handleEscKeyPress);
    };
  }, [onClose]);

  // Pre-cargar imágenes (opcional, podría hacerse a nivel de App)
  useEffect(() => {
    const images = [errIcon, okIcon];
    images.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
    });
  }, []);

  if (!type || !message) { // Si no hay tipo o mensaje, no renderizar nada.
    return null;
  }

  let title = propTitle; // Usar título de prop si se provee
  let contentClass = '';

  if (type === 'success') {
    if (!title) title = '¡Operación Exitosa!'; // Título por defecto
    contentClass = 'success';
  } else if (type === 'error') {
    if (!title) title = 'Ocurrió un Error'; // Título por defecto
    contentClass = 'error';
  } else { // Podrías tener 'info', 'warning'
    if (!title) title = 'Aviso'; // Título por defecto
    contentClass = 'info';
  }

  return (
    <div className="message-overlay" onClick={onClose}>
      <div className={`message-content ${contentClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="message-header">
          <MessageIcon type={type} />
          <h1>{title}</h1>
        </div>
        <div className="message-body">
            <p>{message}</p>
            {type === 'error' && showContactInfoOnError && (
                <div className="contact-info">
                    <p>
                      <strong>Aun no te encuentras registrado?</strong> Comunicate inmediatamente con tu 
                      Secretario General Delegacional o Representante de Centro de Trabajo 
                      para realizar la validacion correspondiente. 
                    </p>

                    {/*<p>Favor de contactar a tu Coordinador de Región </p>  o comunícate a:</p>
                    <div className='contact-details'>
                        <strong>Secretaría General:</strong>
                        <p>3332504177 - WhatsApp</p>
                        <p>3345353732 - fijo</p>
                    </div>
                    <div className='contact-details'>
                        <strong>Secretaría Técnica:</strong>
                        <p>3345353687</p>
                    </div>
                    */}
                </div>
            )}
        </div>
        <div className="message-footer">
          <button onClick={onClose} className="message-button">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};